import remarkGfm from "remark-gfm";

import { Balloon } from "./balloon";
import { MemoizedReactMarkdown } from "./markdown";
import { cn } from "./utils";
import { Message as MessageType } from "@sdr/schemas/message";
import { WithClassName } from "@exact-magic/react-utils";

interface MessageProps extends WithClassName {
  message: MessageType;
}

export const Message = ({ message, className }: MessageProps) => {
  if (!message.content || message.content == 'null') {
    return null;
  }

  if (message.role !== "assistant" && message.role !== "user") {
    return null;
  }

  return (
    <Balloon role={message.role} className={className}>
      <MemoizedReactMarkdown
        className={cn("prose px-5 text-sm", {
          "text-white prose-invert": message.role === "user",
        })}
        remarkPlugins={[remarkGfm]}
        components={{
          p({ children }) {
            return <p className="mb-2 last:mb-0">{children}</p>;
          },
          a({ children, href }) {
            return (
              <a href={href} className="!text-inherit" target="_blank">
                {children}
              </a>
            );
          },
        }}
      >
        {String(message.content)}
      </MemoizedReactMarkdown>
    </Balloon>
  );
};
